/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Wrapper } from './styles';
import { ReactComponent as ErrorImg } from '../../../assets/icons/error-boundary-icon.svg';
import { Button } from '../Button';


// Rendered by the root ErrorBoundary, which sits outside the Router, so router hooks are unavailable here.
const Error = () => {

    return (
        <Wrapper>
            <ErrorImg />
            <h1>Whoops! <br />
                Something went wrong :(</h1>

            <p>We're sorry, it looks like we hit a snag. Please try refreshing your browser or reach out <br /> to our support team at <span>support@klasha.com</span></p>

            <Button theme='primary' label='GO HOME' width='150px' onClick={() => window.location.assign('/')} />


        </Wrapper>
    )
}

export default Error